<template>
    <div class="textarea-wrapper">
        <label v-if="label" :for="id" class="textarea-label">{{ label }}</label>
        <textarea
            :value="value"
            @input="updateValue"
            :required="required"
            :placeholder="placeholder"
            :id="id"
            :cols="cols"
            :rows="rows"
            :class="{
                'textarea-field_gray': gray,
                _error: error
            }"
            class="textarea-field"
        ></textarea>
        <template v-if="error">
            <p
                v-for="(item, index) in error"
                :key="index"
                class="textarea-error-text"
            >
                {{ item }}
            </p>
        </template>
    </div>
</template>

<script>
export default {
    props: [
        "id",
        "label",
        "value",
        "gray",
        "placeholder",
        "error",
        "cols",
        "rows",
        "required"
    ],
    methods: {
        updateValue(event) {
            this.$emit("input", event.target.value);
        }
    }
};
</script>

<style lang="scss" scoped>
.textarea-wrap {
    display: flex;
    flex-direction: column;
}

.textarea-label {
    display: block;
    font-family: "Montserrat";
    font-size: 15px;
    font-weight: 500;
    line-height: normal;
    color: #000;
    &:not(:last-child) {
        margin-bottom: 12px;
    }
}

.textarea-field {
    border-radius: 5px !important;
    border: 1px solid #fff;
    outline: none;
    width: 100%;
    display: block;
    padding: 12px 16px;
    color: inherit;
    font-size: 15px;
    background-color: #fff;
    &:focus {
        outline: none;
        border-color: #6fda44;
    }
    &._error {
        border-color: #da6844;

        &:focus {
            border-color: #6fda44;
        }
    }

    &_gray {
        background-color: #f4f4f4;
        border-color: #f4f4f4;
    }
}

.textarea-error-text {
    font-family: "Montserrat";
    font-size: 10px;
    font-weight: 500;
    line-height: normal;
    color: #da6844;
}
</style>
